
import ZUtil from './zutil';
import ZLog from './zlog';
import ZAPI from './zapi';
import { AUTH } from './AMCAuth';
import { APP } from './App';
//import io from 'socket.io-client';


var ZNetwork = {
	ROOTURL: function(platform) { 
		platform = platform || ZUtil.getPlatform();
		switch (platform) {
			case "production" :
				return "https://server.automatic.ai";
			case "staging" :
				return "https://server.fab.ai";
			default :
				return "http://192.168.86.216:5010";
		}
	},
	ZOOURL: "/v1",
	CHECKOUTURL: "/checkout",
	ADMINURL: "/admins",
	init: function(callback) {
		ZLog.debug("ZNetwork.init");
		this._setupSession((err, user, settings) => {
			if (err) {
				ZLog.fatal("ZNetwork.init Unable to contact user and guest session management server");
				return callback("connecting error");
			}
			ZAPI.connect(user.uri, (err) => {
				ZLog.debug("ZNetwork.init", {user: user.uri});
				callback();
			});
		});
	},
	_setupSession: function(callback) {
		if (ZUtil.getPlatform() === "dev" && !ZUtil.getCandy('username')) {
			ZLog.error("username not found");
		}
		var identity = ZUtil.getCandy('username') || ZUtil.fingerprint();
		ZNetwork.ajax({
			type: 'GET', 
			url: this.ROOTURL() + this.ZOOURL + '/welcome/' + identity,
			success: function(result) {
				let { user, settings, group, version, err } = JSON.parse(result);
				console.log("Server version: " + version);
				if (err === "signin") {
					if (!window.location.href.endsWith("/signin")) {
						window.location.href = "/signin";
					} else {
						APP.setError("Login expired. Please signin");
					}
				}
				AUTH.signedIn(user, settings, group);
				callback(null, user, settings, group);
			},
			error: function (request, status, error) { 
				callback("_setupSession: error: request=" + request + ",status=" + status + ",error=" + error)
			}
		});
	},

	get: function(what, op, id, callback) {
		if (Array.isArray(what)) {
			what = what.join("/");
		}
		if (typeof id === "function") {
			callback = id;
			id = null;
		} else if (typeof op === "function") {
			callback = op;
			op = null;
			id = null;
		}
		let url = this.ZOOURL + "/" + what;
		if (what.startsWith("checkout:")) {
			what = what.substring("checkout:".length);
			url = this.CHECKOUTURL + "/" + what;
		} else if (what.startsWith("admin:")) {
			what = what.substring("admin:".length);
			url = this.ADMINURL + "/" + what;
		}
		ZLog.debug("ZNetwork.get", {url: url, what: what, op: op, id: id});
		ZNetwork.ajax({
			type: 'GET', 
			url: this.ROOTURL() + url + (op ? "/" + op + (id ? "/" + id : '') : ''),
			success: function(result) {
				if (result) {
					try {
						// TODO do this in express / nginx
						result = JSON.parse(result);
					} catch (e) {
						// ZLog.error("ZNetwork.get BAD JSON", {what: what, op: op, id: id, json: result});
					}
				}
				callback(null, result);
			},
			error: function (request, status, error) { 
				ZLog.error("ZNetwork.get", {what: what, op: op, id: id, request: request, status: status, error: error});
				APP.setError(request.responseText && !request.responseText.startsWith("<") ? request.responseText : `Internal error - unable to get '${what}'`);
				if (callback) {
					callback("ERROR: request=" + request + ",status=" + status + ",error=" + error);
				}
			}
		});
	},
	post: function(cmd, arg1, arg2, content, callback) {
		ZLog.debug("ZNetwork.post", {cmd: cmd, arg1: arg1});
		//console.error("posting command: " + cmd);
		if (typeof content === "function") {
			callback = content;
			content = arg2;
			arg2 = null;
		} else if (typeof arg2 === "function") {
			callback = arg2;
			content = arg1;
			arg2 = null;
			arg1 = null;
		} else if (typeof arg1 === "function") {
			callback = arg1;
			content = null;
			arg2 = null;
			arg1 = null;
		}
		content = content || {};
		var url = this.ZOOURL + "/" + cmd;
		if (cmd.startsWith("checkout:")) {
			cmd = cmd.substring("checkout:".length);
			url = this.CHECKOUTURL + "/" + cmd;
		} else if (cmd.startsWith("admin:")) {
			cmd = cmd.substring("admin:".length);
			url = this.ADMINURL + "/" + cmd;
		}
		if (arg1) {
			url += "/" + arg1;
		}
		if (arg2) {
			url += "/" + arg2;
		}
		let ROOTURL = this.ROOTURL(content.platform);
		ZNetwork.ajax({
			type: 'POST', 
			url: ROOTURL + url,
			data: content,
			success: function(result) {
				if (result && typeof result === "string") {
					try {
						result = JSON.parse(result);
					} catch (e) {
						//OLog.error("ZNetwork.post BAD JSON", {cmd: cmd, arg1: arg1, arg2: arg2, json: result});
					}
				}
				if (callback) {
					callback(null, result);
				}
			},
			error: function (request, status, error) { 
				if (status === 404) {
					ZLog.error("ZNetwork.post not found - " + url);
					APP.setError(request.responseText && !request.responseText.startsWith("<") ? request.responseText : `Internal error - '${cmd}' API endpoint not found`);
				} else {
					ZLog.error("ZNetwork.post", {url: url, cmd: cmd, arg1: arg1, arg2: arg2,  request: request.responseText, status: status, error: error});
					if (request.responseText) {
						try {
							let res = JSON.parse(request.responseText);
							if (res.details) {
								ZLog.error("ZNetwork.post error - " + res.details);
							}
							if (res.msg) {
								APP.setError(res.msg);
							}
						} catch (e) {
							APP.setError(`Internal error - ${typeof request.responseText === "string" ? request.responseText : `unable to '${cmd} ${arg1 ? arg1 : ""}`} `);
						}
					} else {
						APP.setError(`Internal error - unable to post '${cmd} ${arg1 ? arg1 : ""}'`);
					}
				}
				if (callback) {
					callback(request.responseText || "Error"); // "ERROR: response=" + request.responseText + ",status=" + status + ",error=" + error);
				}
			}
		});
	},
	// TODO update to window.fetch
	ajax: function(options) {
		ZLog.debug("ZNetwork.ajax", {url: options.url});
		ZLog.debug("ZNetwork.ajax", {options: options});
		this.last_activity = Date.now();
        	var req = new XMLHttpRequest();
        	req.onreadystatechange = function() {
            		if (req.readyState !== 4) {
                		return;
            		}
            		var s = req.status;
            		if ((s >= 200 && s < 300) || s === 304) {
				options.success(req.responseText);
            		} else if (s === 302) {
				window.location.href = req.responseText;
            		} else {
				options.error(req, s, req.responseText);
			}
		}
		// We want session cookies
		if (options.cookies !== false) {
			req.withCredentials = true;
		}
		var sendable = null;
		var headers = {};
		Object.keys(options.headers || {}).forEach( key => { headers[key.toLowerCase()] = options.headers[key] } );
		if (options.formdata) {
 			req.open('POST', options.url, true);
        		sendable = options.formdata;
		} else if (options.data) {
			if (headers["content-type"] && options.type === 'POST') {
				req.open(options.type, options.url, true);
				sendable = JSON.stringify(options.data);
			} else {
				var _data = [];
				for (var n in options.data) {
					if (options.data[n] !== null && typeof options.data[n] !== "undefined") {
						_data.push(n + "=" + encodeURIComponent(typeof options.data[n] === "string" ? options.data[n] : JSON.stringify(options.data[n])));
					}
				}
	 			_data = _data.join('&');
				if (options.type === 'POST') {
					req.open(options.type, options.url, true);
					headers["content-type"] = "application/x-www-form-urlencoded";
			      		sendable = _data;
				} else {
	 				req.open(options.type, options.url + "?" + _data, true);
					headers["X-Requested-With"] = "XMLHttpRequest";
				}
			}
		} else {
 			req.open(options.type, options.url, true);
		}
		Object.keys(headers).forEach( key => {
			req.setRequestHeader(key, headers[key]);
		});
       		req.send(sendable);
		return req;
	},
	uploadToS3: function(file, signed_request, callback) {
		const xhr = new XMLHttpRequest();
		xhr.open('PUT', signed_request);
		xhr.onreadystatechange = () => {
			if(xhr.readyState === 4){
				if(xhr.status === 200){
					callback(null, file.name);
				} else {
					callback("Could not upload file " + file.name);
				}
			}
		}
		xhr.send(file);
	}
};

export default ZNetwork;



// WEBPACK FOOTER //
// ./src/znetwork.js